import { logType } from './constants/loggerConstants';
import axios from 'axios';
export default class ShellLogger {

  constructor() {

    this.shellSessionId = this._createUUID();
    this.stickyData = {};
  }

  /*
   * Current sticky data:
   * - universalId
   */
  addStickyData(name, value) {
    this.stickyData[name] = value;
  }

  // Call these for different levels of logging
  debug(logEvent='ERROR: LOG EVENT NOT DEFINED', logMessage='No log message defined', messageJson = null) {
    this._logger(logType.DEBUG, logEvent, logMessage, messageJson);
  }

  info(logEvent='ERROR: LOG EVENT NOT DEFINED', logMessage='No log message defined', messageJson = null) {
    this._logger(logType.INFO, logEvent, logMessage, messageJson);
  }

  warning(logEvent='ERROR: LOG EVENT NOT DEFINED', logMessage='No log message defined', messageJson = null) {
    this._logger(logType.WARNING, logEvent, logMessage, messageJson);
  }

  error(logEvent='ERROR: LOG EVENT NOT DEFINED', logMessage='No log message defined', messageJson = null) {
    this._logger(logType.ERROR, logEvent, logMessage, messageJson);
  }

  // Log function (wrapped by different log levels, call those instead)
  _logger(logType, logEvent, logMessage, jsonPayload) {

    const splunkAPIKey = process.env.REACT_APP_SPLUNK_API_KEY;
    const cctEndpoint = process.env.REACT_APP_SPLUNK_URL;

    // Add data to the body
    const loggingObject = {
      eventType: logEvent,
      eventMessage: logMessage,
      intuSourceSystem: 'Standalone Chat Shell',
      shellSessionId: this.shellSessionId,
      TimeStamp: new Date(Date.now()),
      Type: logType
    };
    // Only add jsonPayload if it exists
    if (jsonPayload) {
      loggingObject.messageJSON = jsonPayload;
    }
    // Add stickyData
    for (const key in this.stickyData) {
      // Avoid logging default inherited object properties
      if (this.stickyData.hasOwnProperty(key)) {
        loggingObject[key] = this.stickyData[key];
      }
    };

    // TODO: Call splunk to log
    axios.post(cctEndpoint, loggingObject, this._createSplunkHeader(splunkAPIKey))
      .then(() => {})
      .catch((err) => {
        console.error(`Unable to call splunk endpoint for logging: ${err}`);
      });
  }

  _createSplunkHeader(apiKey) {
    return {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Intuit_APIKey intuit_apikey=${apiKey}, intuit_apikey_version=1.0`
      }
    };
  }

  _createUUID() {
    try {
      return (
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (curr) => {
          const time = new Date().getTime();
          const rng = (time + Math.random() * 16) % 16 | 0;
          // rng = Math.floor(rng / 16); // TODO: This isn't doing anything to impact rng. Should it?
          // eslint-disable-next-line no-mixed-operators,space-infix-ops
          return (curr === 'x' ? rng : (rng&0x3|0x8)).toString(16); // bit-shift if curr is y
        }));
    }
    catch (e) {
      console.error(`Unable to generate UUID for shell logger sessionId: ${e}`);
      return 'FAILED TO GENERATE UUID';
    }
  }
}